module.exports = __webpack_public_path__ + "static/toggl-hire-29fdbcc75fbff2d2e39d4d78e9ad03a8.mp4";